import {
    DEVICES_BULK_UNPAIRING_OPEN_MODAL,
    DEVICES_BULK_UNPAIRING_CLOSE_MODAL,
    DEVICES_BULK_UNPAIRING_REQUEST,
    DEVICES_BULK_UNPAIRING_RESULT,
    DEVICES_BULK_SEARCH_DEVICE_REQUEST,
    DEVICES_BULK_SEARCH_DEVICE_RESULT,
    DEVICES_BULK_UNPAIRING_SET_DEVICE
} from 'Redux/actionTypes';

export const bulkUnpairingOpenModal = (items) => ({
    type: DEVICES_BULK_UNPAIRING_OPEN_MODAL,
    payload: items,
});

export const bulkUnpairingCloseModal = () => ({
    type: DEVICES_BULK_UNPAIRING_CLOSE_MODAL
});

export const bulkUnpairingRequest = (data) => ({
    type: DEVICES_BULK_UNPAIRING_REQUEST,
    payload: data
});

export const bulkUnpairingResult = (result) => ({
    type: DEVICES_BULK_UNPAIRING_RESULT,
    payload: result
});

export const bulkUnSearchDeviceRequest = (item) => ({
    type: DEVICES_BULK_SEARCH_DEVICE_REQUEST,
    payload: item
});

export const bulkUnSearchDeviceResult = (result) => ({
    type: DEVICES_BULK_SEARCH_DEVICE_RESULT,
    payload: result
});

export const bulkUnpairingSetDevice = (items) => ({
    type: DEVICES_BULK_UNPAIRING_SET_DEVICE,
    payload: items
});
